import React from 'react';

const JobCard = ({ job, onViewJob }) => {
  return (
    <article className="job-card">
      <div className="job-card__top">
        <span className="job-card__department">
          {job.department}
        </span>

        <span className="job-card__posted">
          {job.posted}
        </span>
      </div>

      <div className="job-card__body">
        <h3 className="job-card__title">
          {job.title}
        </h3>

        <p className="job-card__description">
          {job.description}
        </p>

        <div className="job-card__meta">
          <span>
            <span aria-hidden="true">⌖</span>
            {job.location}
          </span>

          <span>
            <span aria-hidden="true">◷</span>
            {job.type}
          </span>

          <span>
            <span aria-hidden="true">◌</span>
            {job.experience}
          </span>
        </div>

        <div className="job-card__skills">
          {job.skills.map((skill) => (
            <span key={skill}>{skill}</span>
          ))}
        </div>
      </div>

      <div className="job-card__footer">
        <button
          type="button"
          className="job-card__button"
          onClick={() => onViewJob(job)}
        >
          View position
          <span aria-hidden="true">→</span>
        </button>
      </div>
    </article>
  );
};

export default JobCard;